import initialState from './initialState'

const SET_INFO_PAYMENT_SUMMARIES = function(state, payloadInfo) {
    state.openingUser = payloadInfo.opening_user
    state.openingTimeStamp = payloadInfo.opening_timestamp
    state.initialAmountCash = payloadInfo.initial_amount_cash
}

const SET_TOTAL_INCOME = (state, income) => {
    state.totalIncome = income
}

const SET_DETAIL_CUSTOMER_SUMMARIES = function(state, payloadCustomer) {
    state.setDetailCustomerSummaries = payloadCustomer
}

const SET_DETAIL_EMPLOYEE_SUMMARIES = function(state, payloadEmployee) {
    state.setDetailEmployeeSummaries = payloadEmployee
}

const SET_DETAIL_EGRESS_SUMMARIES = function(state, payloadEgress) {
    state.setDetailEgressSummaries = payloadEgress
}

const SET_TOTAL_CUSTOMER_SUMMARIES = function(state, total) {
    state.totalCustomerSummaries = total
}

const SET_TOTAL_EMPLOYEE_SUMMARIES = function(state, total) {
    state.totalEmployeeSummaries = total
}

const SET_INITIAL_AMOUNT_CASH = (state, amount) => {
    state.initialAmountCash = amount
}

export default {
    SET_INFO_PAYMENT_SUMMARIES,
    SET_DETAIL_CUSTOMER_SUMMARIES,
    SET_DETAIL_EMPLOYEE_SUMMARIES,
    SET_DETAIL_EGRESS_SUMMARIES,
    SET_TOTAL_CUSTOMER_SUMMARIES,
    SET_TOTAL_EMPLOYEE_SUMMARIES,
    SET_TOTAL_INCOME,
    SET_INITIAL_AMOUNT_CASH,
}
